
export {
    convertInquiryTypeToText,
    convertMailTypeToText,
    convertMessageError,
    handleDownloadAttachment,
    setupIconClickEvent,
    tinymceOptions,
    setupLanguageTinymce,
    focusAtBrLine,
    notifyEmptyReceive,
    notifyEmptyTrash,
    notifyInquiryPeriodLimit,
    getDateRange,
    convertLineBreakBody,
    getDateDefault,
}
const notifyEmptyReceive = 'メールが削除されました。';
const notifyEmptyTrash = 'このメールはゴミ箱に存在しません。';
const notifyInquiryPeriodLimit  = 'お問合せ期間を3か月以内に設定してください';

function convertInquiryTypeToText(inquiryType) {
    let resultConvert = ''
    if (inquiryType === 0) {
        resultConvert = 'メール'
    } else if(inquiryType === 1) {
        resultConvert = '電話'
    } else if(inquiryType === 2) {
        resultConvert = '営業'
    } else if(inquiryType === 9) {
        resultConvert = 'その他'
    }
    return resultConvert
}

function convertMailTypeToText (type, kinds_name, state_flg) {
    let resultConvert = ''
    resultConvert = kinds_name
    if (state_flg === -1){
        resultConvert = '未設定'
    }
    return resultConvert
}

function convertMessageError (message) {
    let resultMessage = '処理に失敗しました。'
    if (message === 'Network Error') {
        resultMessage = 'インタネットが繋がりません。'
    }
    return resultMessage
}

function handleDownloadAttachment (result) {
    const content = result.file_data;
    let fileName = result.file_name;
    let typeDownload = result.file_type;
    // Decode base64 using atob method
    let data = window.atob(content);
    let bytes = new Array(data.length);
    for (let i = 0; i < data.length; i++) {
        bytes[i] = data.charCodeAt(i);
    }
    data = new Uint8Array(bytes);
    let anchor = document.createElement('a');
    if (anchor.download !== undefined) {
      let blob = new Blob([data], {type: typeDownload});
      var objectURL = window.URL.createObjectURL(blob);

      anchor.href = objectURL;
      anchor.download = fileName;
    }
    if (navigator.msSaveBlob) { // IE 10+
      anchor.addEventListener("click", function (event) {
        let blob = new Blob([data], {
          "type": 'text'
        });
        navigator.msSaveBlob(blob, fileName);
      }, false);
    }

    anchor.click();

    URL.revokeObjectURL(objectURL);
}

function setupIconClickEvent() {
    window.addEventListener('click', (event) => {
        const target = event.target;
        const isIcon = target.classList.contains('icon-after');
        if (isIcon) {
            const inputField = target.closest('.vs-input');
            if(inputField){
                const inputModel = inputField.__vue__.$vnode;
                inputModel.context.clearInput(inputModel.data.model.expression);
            }
        }
    });
}

const tinymceOptions = {
    menubar:false,
    language: 'ja',
    plugins: 'advlist lists link image imagetools media charmap code codesample directionality emoticons',
    toolbar1: `bold italic underline strikethrough blockquote preformat numlist bullist subscript superscript | outdent indent |
        ltr rtl fontsizeselect formatselect forecolor backcolor fontselect align removeformat link image imagetools media`,
    content_style: `
        body { 
            font-family: Helvetica,Arial,sans-serif;
            font-size:13px;
            color: #626262;
        }
        p, div {
            margin: 0px 7px;
            line-height: 1.42 !important;
        }
        p:has(p), div:has(div) {
            margin: 0px 0px;
        }
        a {
            cursor: pointer;
        }
        blockquote {
            border-left: 2px solid #ccc;
            padding-left: 1rem;
            margin: 5px 0px 5px 1.5rem
        }
    `,
    forced_root_block: 'p',
    force_br_newlines: false,
    force_p_newlines: true,
    valid_elements: 'p,br,b,strong,i,em,u,ul,ol,li,a[href],h1,h2,h3,h4,h5,h6,img[src|alt|width|height],iframe[src|allowFullscreen],pre,span,blockquote,hr,video[width|height|poster|controls|src],source[src|type],div',
    extended_valid_elements: '',
    branding: false,
    //Image
    image_dimensions: false,
    image_description: false,
    file_picker_types: 'image',
    automatic_uploads: false,
    file_picker_callback: function (callback, value, meta) {
        if (meta.filetype === 'image') {
            const input = document.createElement('input');
            input.type = 'file';
            input.accept = 'image/*';

            input.onchange = () => {
                const file = input.files[0];
                if (!file) return;

                const maxWidth = 800, quality = 0.7;
                const reader = new FileReader();

                reader.onload = () => {
                    const img = new Image();
                    img.onload = () => {
                        // Image smaller than threshold → keep base64
                        if (img.width <= maxWidth) return callback(reader.result);
                        // Resize if image is too large
                        const scale = maxWidth / img.width;
                        const canvas = Object.assign(document.createElement('canvas'), {
                            width: maxWidth,
                            height: img.height * scale
                        });
                        canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);

                        canvas.toBlob(blob => {
                            const r2 = new FileReader();
                            r2.onload = () => callback(r2.result);
                            r2.readAsDataURL(blob);
                        }, 'image/jpeg', quality);
                    };
                    img.src = reader.result;
                };

                reader.readAsDataURL(file);
            };

            input.click();
        }
    },
    // media
    media_poster: false,
    media_alt_source: false,
    media_dimensions: false,
    // link
    target_list: false,
    link_title: false,
    default_link_target: '_blank',
    placeholder: '',
    setup: function (editor) {
        function normalizeDivToP(rootNode) {
            if (!rootNode) return;
            // Convert all <div> to <p> for pre-normalization
            const divs = rootNode.querySelectorAll('div');
            divs.forEach(div => {
                // Wrap direct text node in <p>
                for (let child of div.childNodes) {
                    const isText = child.nodeType === 3 && child.textContent;
                    const isSpan = child.nodeType === 1 && child.tagName.toLowerCase() === "span" && child.textContent;
                    const isSpanBr = child.nodeType === 1 && child.tagName.toLowerCase() === "span" && /^<br\s*\/?>$/i.test(child.innerHTML);
                    if (isText || isSpan) {
                        const p = document.createElement("p");
                        p.textContent = child.textContent;
                        child.replaceWith(p);
                    }else if (isSpanBr) {
                        const p = document.createElement("p");
                        p.innerHTML = "&nbsp;";
                        child.replaceWith(p);
                    }
                }
                // Skip if there are child divs (will be handle later)
                if (div.querySelector("div")) return;
                const p = document.createElement('p');
                p.innerHTML = div.innerHTML;
                div.replaceWith(p);
            });
        }
        // when the user right clicks
        editor.on('contextmenu', function (e) {
            const target = e.target;
            const nodeName = target.nodeName.toLowerCase();

            // If it is <a> or <img> → let TinyMCE handle the context menu
            if (nodeName === 'a' || nodeName === 'img') {
                e.preventDefault();
                editor.execCommand('contextMenu');
            } else {
                // If not → allow browser default menu
                e.stopImmediatePropagation();
            }
        });
        // Delete comment before returning content
        editor.on('BeforeSetContent', (data) => {
            if (data.content) {
                data.content = data.content.replace(/<!--[\s\S]*?-->/g, '');
            }
        });
        // When pasting content
        editor.on('Paste drop', (e) => {
            setTimeout(() => {
                const body = editor.getBody();
                normalizeDivToP(body);
            }, 0);
        });
        // Register a toggle button to switch the current block to <pre> format
        editor.ui.registry.addToggleButton('preformat', {
            tooltip: 'Source code',
            icon: 'sourcecode',
            onAction: function () {
                editor.execCommand('FormatBlock', false, 'pre');
            }
        });
        // When the editor content is set
        editor.on('SetContent', () => {
            const body = editor.getBody();
            normalizeDivToP(body);
            const ps = body.querySelectorAll('p');

            ps.forEach(p => {
                const html = p.innerHTML;
                // Skip paragraphs that don't contain <br> tags
                if (!/<br\s*\/?>/i.test(html)) return;
                const lines = html.split(/<br\s*\/?>/i);
                if (lines.length > 0 && lines[lines.length - 1].trim() === '') {
                    lines.pop();
                }
                // Create a document fragment to batch insert new elements
                const fragment = document.createDocumentFragment();

                lines.forEach(line => {
                    const trimmed = line.trim();
                    // Create a new <p> for each line
                    // If the line is empty, preserve spacing using &nbsp;<br>
                    const newP = document.createElement('p');
                    newP.innerHTML = trimmed ? trimmed : '&nbsp;';
                    fragment.appendChild(newP);
                });
                // Replace the original <p> with the newly created multiple <p> blocks
                p.replaceWith(fragment);
            });
        });

        editor.on('Change', () => {
            const spans = editor.getBody().querySelectorAll('span[data-mce-object="iframe"], span[data-mce-object="video"]');
            if (!spans) return;
            spans.forEach(span => {
                span.setAttribute('contenteditable', 'false');
            });
        });

        editor.on('keydown', function (e) {
            if (e.key === 'Enter') {
                const node = editor.selection && editor.selection.getNode();
                if (!node) return;

                if (typeof node.closest !== 'function') return;

                const iframeSpan = node.closest('span[data-mce-object="iframe"]');
                if (!iframeSpan || typeof iframeSpan.closest !== 'function') return;

                const p = iframeSpan.closest('p');

                if (p) {
                    e.preventDefault();
                    const newP = document.createElement('p');
                    newP.innerHTML = '<br>';
                    p.insertAdjacentElement('afterend', newP);
                    const rng = editor.dom.createRng();
                    rng.setStart(newP, 0);
                    rng.setEnd(newP, 0);
                    editor.selection.setRng(rng);
                    editor.focus();
                }
            }
        });
    }
};

function setupLanguageTinymce() {
    if (window.tinymce && typeof tinymce.addI18n === 'function') {
        tinymce.addI18n('ja', {
            "Source code": "ソースコード",
            "Insert\/edit image": "画像の挿入/編集",
            "Edit image": "画像の編集",
            "Source": "ソース",
            "Save": "保存",
            "Cancel": "キャンセル",
            "Insert\/edit media": "メディアの挿入・編集",
            "General": "一般",
            "Paste your embed code below:": "埋め込み用コードを下記に貼り付けてください。",
            "Embed": "埋め込み",
            "Insert\/edit link": "リンクの挿入・編集",
            "Text to display": "表示するテキスト",
            "Open link": "リンクを開く",
            "Remove link": "リンクを削除",
            "Color Picker": "カラーピッカー",
            "Left": "左揃え",
            "Center": "中央揃え",
            "Right": "右揃え",
            "Justify": "両端揃え",
            "Width": "幅",
            "Height": "高さ",
            "Apply": "適用",
            "Back": "戻る",
            "Bold": "太字",
            "Italic": "斜体",
            "Underline": "下線",
            "Strikethrough": "取消線",
            "Blockquote": "Blockquote",
            "Default": "デフォルト",
            "Circle": "円",
            "Disc": "点",
            "Square": "四角",
            "Lower Alpha": "小文字のアルファベット",
            "Lower Greek": "小文字のギリシャ文字",
            "Lower Roman": "小文字のローマ数字",
            "Upper Alpha": "大文字のアルファベット",
            "Upper Roman": "大文字のローマ数字",
            "Superscript": "上付き",
            "Subscript": "下付き",
            "Inline": "インライン",
            "Blocks": "ブロック",
            "Left to right": "左から右",
            "Right to left": "右から左",
            "Clear formatting": "書式をクリア",
            "Bullet list": "箇条書き",
            "Numbered list": "番号付き箇条書き",
            "Font Sizes": "フォントサイズ",
            "Background color": "背景色",
            "Fonts": "フォント",
            "Text color": "テキストの色",
            "Align": "配置",
            "Decrease indent": "インデントを減らす",
            "Increase indent": "インデントを増やす",
            "Link...": "リンク...",
            "Image...": "画像.."
        });
    }
}

function focusAtBrLine(tinymceEditor, routeName) {
    if (!tinymceEditor) return;

    const editor = tinymceEditor;
    editor.focus();

    const doc = editor.getDoc();
    if (!doc || !doc.body) return;

    const body = doc.body;
    const selection = doc.defaultView.getSelection();
    const range = doc.createRange();

    let target = null;

    if (routeName !== 'create-mail') {
        // Find all <br> in body
        const brs = body.querySelectorAll('br');
        if (brs.length >= 3) {
            target = brs[2];
        } else {
            // If not enough <br>, find <p>
            const ps = body.querySelectorAll('p');
            if (ps.length >= 3) {
                target = ps[2];
            }
        }
    }

    if (target) {
        range.setStartBefore(target);
    } else {
        // If nothing → focus on the body
        range.setStart(body, 0);
    }

    range.collapse(true);
    selection.removeAllRanges();
    selection.addRange(range);
}

// 表示期間の範囲を日付で取得
function getDateRange(dateFrom, dateTo) {
    const start = new Date(dateFrom).getTime();
    const end = new Date(dateTo).getTime();

    if (isNaN(start) || isNaN(end)) return 0;

    return Math.floor((end - start) / (1000 * 60 * 60 * 24));
}

function convertLineBreakBody(body){
    if (!body) return '';

    return body.replace(
        /<p[^>]*>(?:\s|&nbsp;|<br\s*\/?>|<span[^>]*>(?:\s|&nbsp;|<br\s*\/?>)*<\/span>)*<\/p>/gi,
        '<p>&nbsp;</p>'
    );
}

function getDateDefault(type = 'from', days = 13) {
    let defaultDate = new Date();
    const optionsLocale = {
        timeZone: 'Asia/Tokyo',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    };
    // Subtract days for 'from' type, otherwise keep current date as default
    if (type == 'from') {
        defaultDate.setDate(defaultDate.getDate() - days);
    }
    //Format date according to Asia/Tokyo timezone and standardize to YYYY-MM-DD format
    return defaultDate.toLocaleString('ja-JP', optionsLocale).slice(0,10).replace(/\//g, '-');
}